import API from './api';

export default class UserApi {
  static authenticate(params) {
    return API.post('/advertisers/sessions', params);
  }

  static authenticateMember(params) {
    return API.post('/advertisers/users/sessions', params);
  }

  static refreshToken(params) {
    return API.post('/advertisers/sessions/refresh_token', params);
  }

  static refreshTokenMember(params) {
    return API.post('/advertisers/users/sessions/refresh_token', params);
  }

  static authenticateViaToken(params) {
    return API.post('/advertisers/sessions/create_by_token', params);
  }

  static register(params, urlParams) {
    return API.post('/advertisers/registrations/register', params, urlParams);
  }

  static resendVerification(params) {
    return API.post('/advertisers/registrations/resend_verification', params);
  }

  static verify(params) {
    return API.post('/advertisers/registrations/verify', params);
  }

  static current() {
    return API.get('/advertisers/networks/current');
  }

  static currentMember() {
    return API.get('/advertisers/users/network_users/current');
  }

  static get(id, params) {
    return API.get(`/advertisers/networks/${id}`, params);
  }

  static update(id, params) {
    return API.put(`/advertisers/networks/${id}`, params);
  }
}
